<form [formGroup]="questionForm">

  <ng-container *ngIf="question">
    <span *ngFor="let activity of question.inputList; index as activityInpIndex">
      <span [innerHTML]="activity.activityText"  *ngIf="!(activity.controlVisibility && activity.controlVisibility == 'hidden')"></span>
      <span [ngSwitch]="activity.type" *ngIf="!(activity.controlVisibility && activity.controlVisibility == 'hidden')">

          <span class="goal-textfeild">
          <app-num-text-box id="calc-text" *ngSwitchCase="'numeric-box'" [activity]="activity" [activityControl]="questionForm.get('inputList')['controls'][activityInpIndex]"
          [activityInputList]="question.inputList" [questionForm]="questionForm"></app-num-text-box>
          </span>
        <span  class="goals-dropdown">
        <app-dropdown id="dd-calc" [qusId]="question.qusId" [pillarName]="pillarName" *ngSwitchCase="'dropdown'" [activity]="activity" [activityControl]="questionForm.get('inputList')['controls'][activityInpIndex]"
          [activityInputList]="question.inputList" [questionForm]="questionForm"></app-dropdown>
        </span>
          <span  class="goals-dropdown">
          <app-dropdown-multiple id="dd-multiple" *ngSwitchCase="'dropdown-multiple'" [activity]="activity" [activityControl]="questionForm.get('inputList')['controls'][activityInpIndex]"
          [activityInputList]="question.inputList"></app-dropdown-multiple>
        </span>
          <span class="gigaton-text-field">
        <app-text-box id="calc-textbox" *ngSwitchCase="'text-box'" [activity]="activity" [activityControl]="questionForm.get('inputList')['controls'][activityInpIndex]"></app-text-box>
      </span>
        <app-email-field id="email" *ngSwitchCase="'email'" [activity]="activity" [activityControl]="questionForm.get('inputList')['controls'][activityInpIndex]"
        ></app-email-field>
        <span class="urlfeild">
          <app-url-field id="weburl" *ngSwitchCase="'weburl'" [activity]="activity" [activityControl]="questionForm.get('inputList')['controls'][activityInpIndex]"
        ></app-url-field>
        </span>
        <span class="gigaton-text-field">
          <app-text-box *ngSwitchCase="'text-field'" [activity]="activity" [activityControl]="questionForm.get('inputList')['controls'][activityInpIndex]" ></app-text-box>
        </span>
        <span class="goal-checkbox">
          <calculator-checkbox id="calc-checkbox" *ngSwitchCase="'checkbox'" [activity]="activity" [activityControl]="questionForm.get('inputList')['controls'][activityInpIndex]" [questionForm]="questionForm"></calculator-checkbox>
        </span>
      </span>
    </span>
  </ng-container>
  <ng-container *ngIf="questionForm.touched">
    {{setQuestionStatus('updated')}}
  </ng-container>
  <div *ngIf="question['errors'] && question['errors']['flag']">
    <mat-error>
      {{question['errors']['msg']}}
    </mat-error>
  </div>
</form>
